import { render, staticRenderFns } from "./secondInfo.vue?vue&type=template&id=954cb5ee&scoped=true"
import script from "./secondInfo.vue?vue&type=script&lang=js"
export * from "./secondInfo.vue?vue&type=script&lang=js"
import style0 from "./secondInfo.vue?vue&type=style&index=0&id=954cb5ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954cb5ee",
  null
  
)

export default component.exports